import { render, staticRenderFns } from "./Qu.vue?vue&type=template&id=07ac47b9&scoped=true"
import script from "./Qu.vue?vue&type=script&lang=js"
export * from "./Qu.vue?vue&type=script&lang=js"
import style0 from "./Qu.vue?vue&type=style&index=0&id=07ac47b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac47b9",
  null
  
)

export default component.exports